import { BuildConfigService } from '@dgx-pr-spa/ui-components';
import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-covid-banner',
  templateUrl: './covid-banner.component.html',
  styleUrls: ['./covid-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CovidBannerComponent {
  constructor(public readonly configService: BuildConfigService) {}
}
